import {
  FormContainer,
  ISelectCountry,
  QPFQuickRegisterForm,
  SwitchInput,
  useFetch,
} from "@4uhub/lib4uhub";
import { BlacklistService } from "../../../../../services/blacklist.service";
import { useTranslation } from "react-i18next";
import { blacklistSchema, TBlacklistForm } from "./BlacklistSchema";
import { Grid } from "@mui/material";
import { BlacklistContact } from "./BlacklistContact";
import { useCallback, useEffect, useState } from "react";
import { countriesList } from "../../../../../services/country.service";

const blacklistService = new BlacklistService();

const translationPath = "chatBot.page.service.blacklist.";

export const Blacklist = () => {
  const { t } = useTranslation();

  const [countries, setCountries] = useState<ISelectCountry[]>([]);

  const { sendRequest } = useFetch(countriesList);

  const { sendRequest: save, loading: sLoading } = useFetch(
    blacklistService.create
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    blacklistService.updateItemById
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    blacklistService.getItemById
  );

  const loading = sLoading || uLoading || gLoading;

  const saveHandler = (v: TBlacklistForm) => {
    return save({
      ...v,
      phoneNumber: `${v.ddi.ddiCode || ""}${v.phoneNumberValue.replace(
        /\D/g,
        ""
      )}`,
      individualId: v.individual.identifier,
    });
  };

  const updateHandler = (v: TBlacklistForm, id: string) => {
    return update({
      item: {
        ...v,
        phoneNumber: `${v.ddi.ddiCode || ""}${v.phoneNumberValue.replace(
          /\D/g,
          ""
        )}`,
        individualId: v.individual.identifier,
      },
      id,
    });
  };

  const getHandler = useCallback(
    async (id: string) => {
      const { data, success } = await get(id);

      if (data) {
        const country = countries.find(
          (c) => data.phoneNumber?.slice(0, c.ddiCode?.length) === c.ddiCode
        );
        const phoneNumber = data.phoneNumber.slice(country?.ddiCode.length);

        const dataProcessed: TBlacklistForm = {
          ...data,
          ddi: country!,
          phoneNumberValue: phoneNumber,
          individual: {
            document: data.individual.code,
            identifier: data.individual.id,
            individualName: data.individual.name,
            establishmentId: data.individual.establishmentId,
          },
        };

        return {
          data: dataProcessed,
          success,
        };
      }

      return {
        data: null,
        success: false,
      };
    },
    [get, countries]
  );

  const fetchCountries = useCallback(async () => {
    const { data, success } = await sendRequest(null);

    if (success && data) {
      const sortedData = data.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      setCountries(sortedData);
    }
  }, [setCountries, sendRequest]);

  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  return (
    <FormContainer<TBlacklistForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "blacklist_registration")}
      schema={blacklistSchema}
      subtitle={t(translationPath + "blacklist_registration")}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item textAlign={"end"} xs={12} sm={12}>
            <SwitchInput label={t(translationPath + "enable")} name="enable" />
          </Grid>
          <Grid item xs={12} sm={12}>
            <QPFQuickRegisterForm
              name="individual"
              label={t(translationPath + "individual") || "Individual"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <BlacklistContact countries={countries} />
          </Grid>
        </Grid>
      )}
    />
  );
};
